import { useState } from "react";
import { useTranslation } from "react-i18next";
import { createTypographyHelper } from "../../../../../utils/typography";
import customAxios from "../../../../../utils/customAxios";
import { MotionModal, ModalCloseButton } from "../../../../../components/motion";

const CancelBookingSuccessModal = ({
    show = false,
    onClose = () => { },
    setNoticeShow,
    bookingId,
    onDiscardSuccess,
}) => {
    const { t, i18n } = useTranslation();
    const getTypographyClass = createTypographyHelper(i18n.language);
    const [isProcessing, setIsProcessing] = useState(false);

    const onConfirm = async () => {
        try {
            setIsProcessing(true);
            await customAxios.post(
                "/api/request-change-booking/ignore-rejection",
                { bookingId },
                { headers: { "Content-Type": "application/json" } }
            );
            onDiscardSuccess?.();
        } catch (error) {
            console.error("Ignore rejection failed:", error?.response?.data || error);
        } finally {
            setIsProcessing(false);
            setNoticeShow(false);
            onClose();
        }
    };

    return (
        <MotionModal
            show={show}
            onClose={onClose}
            maxWidthClassName="tw:max-w-[660px]"
            panelClassName="tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8"
        >
                <ModalCloseButton onClick={onClose} />

                <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-6">
                    <div className="tw:text-[#282828] tw:text-[18px] tw:font-[600] tw:leading-[25px] tw:font-semibold tw:font-hanken-grotesk tw:mb-1 tw:max-w-[560px]">
                        {t("bookingDetail.status.discardNoticeModal.title")}
                    </div>

                    <div className="tw:!grid tw:!w-full tw:!mb-6">
                        <p className="tw:!text-[#666666] tw:!text-[15px] tw:!font-[400] tw:!mb-0"
                            dangerouslySetInnerHTML={{ __html: t("bookingDetail.status.discardNoticeModal.description") }}
                        >
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="tw:!grid tw:!grid-cols-2 tw:!gap-4 tw:!w-full">
                        <button
                            onClick={onClose}
                            className="tw:!border tw:!border-[#ccc] tw:!rounded-[8px] tw:!py-3 tw:!font-[400] tw:!text-[#282828] tw:hover:!bg-gray-50 tw:!transition-colors tw:!w-full"
                        >
                            <span className={getTypographyClass(14)}>{t("bookingDetail.status.discardNoticeModal.back")}</span>
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isProcessing}
                            style={{ opacity: isProcessing ? 0.6 : 1 }}
                            className="tw:!bg-[#f34336] tw:!rounded-[8px] tw:!py-3 tw:!font-bold tw:!text-white tw:hover:!bg-[#d32f2f] tw:!transition-colors tw:!w-full"
                        >
                            <span className={getTypographyClass(14)}>{isProcessing ? "..." : t("bookingDetail.status.discardNoticeModal.discardNotice")}</span>
                        </button>
                    </div>

                </div>
        </MotionModal>
    );
};

export default CancelBookingSuccessModal;